import { Controller } from "@hotwired/stimulus"

// Footer "Preferências de cookies" trigger (#511). Reopens the consent banner
// via a decoupled document event the banner controller (cookie-consent)
// listens for — so the trigger can live anywhere (footer, settings) without
// being inside the banner's DOM scope.
export default class extends Controller {
  open(event) {
    if (event) event.preventDefault()
    document.dispatchEvent(new CustomEvent("opinaki:open-consent"))
  }
}
